<template>
    <div class="rounded-xl border border-valence-grey-300 px-4 py-8 md:px-8 bg-white">
        <div v-if="skipped" class="flex flex-col gap-2">
            <p class="body-small text-valence-grey-500">The roleplay was too short to generate a summary. Try engaging in a longer conversation to get meaningful feedback.</p>
        </div>
        <div v-else class="flex flex-col gap-2">
            <h1 class="display-serif">How did that go?</h1>
            <Transition name="fade" mode="out-in">
                <MarkdownText v-if="overallSummary" class="body-small font-normal" :text="overallSummary" />
                <div v-else-if="summaryState.overallSummary === STATE.LOADING" class="flex flex-col gap-2">
                    <SkeletonLoader v-for="i in 2" :key="i" :class="[textSkeletonClass]"></SkeletonLoader>
                </div>
            </Transition>
            <div class="grid md:grid-cols-2 gap-8 mt-4">
                <div
                    v-for="({ type, list, state }, index) in [
                        { type: 'strengths', list: strengths, state: summaryState.strengths },
                        { type: 'weaknesses', list: weaknesses, state: summaryState.weaknesses },
                    ]"
                    :key="index">
                    <span v-if="type === 'strengths'" class="body-small-bold bg-[#FFE4EC] rounded-lg py-1 px-2">Where you did well</span>
                    <span v-else class="body-small-bold bg-[#FFF0E5] rounded-lg py-1 px-2">Room for Improvement</span>
                    <ul class="pl-6 my-3 flex flex-col gap-4">
                        <template v-if="state === STATE.LOADING">
                            <li v-for="i in 2" :key="i" class="list-disc">
                                <SkeletonLoader v-for="j in 3" :key="j" :class="['mb-1', textSkeletonClass]"></SkeletonLoader>
                                <SkeletonLoader :class="[textSkeletonClass, 'w-1/2!']"></SkeletonLoader>
                            </li>
                        </template>
                        <template v-else-if="state === STATE.LOADED">
                            <template v-if="list && list.length > 0">
                                <li v-for="item in list" :key="item" class="list-disc">
                                    <MarkdownText class="body-small font-normal" :text="item" />
                                </li>
                            </template>
                            <li v-else>Not enough data from this conversation</li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import SkeletonLoader from "~vue/components/SkeletonLoader.vue";
import MarkdownText from "~vue/MarkdownText.vue";
import { STATE } from "~vue/pages/RolePlaySummary.vue";

const { strengths } = defineProps({
    strengths: { type: Array, default: null },
    weaknesses: { type: Array, default: null },
    overallSummary: { type: String, default: null },
    summaryState: { type: Object, default: () => ({}) },
    skipped: { type: Boolean, default: false },
});

const textSkeletonClass = "w-full h-[0.75lh] rounded-md mt-1";
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 200ms ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
